export default {
  setIssues(state, payload) {
    state.data = payload;
  },
  setIssuesStatus(state, payload) {
    if (payload !== 'Error') {
      state.errMessage = null;
    }
    state.status = payload;
  },
  setIssuesErrMessage(state, payload) {
    state.status = 'Error';
    state.errMessage = payload;
  },
  CLEAR(state) {
    state.data = [];
    state.status = 'Unfetched';
    state.errMessage = null;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/issues/mutations.js